import { InputBase } from "@material-ui/core";
import { memo } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { RootState } from "../../store";

type UrlSelector = (state: RootState) => string | null;

const DummyRedirect = memo<{ url: string | null }>(({ url }) => {
  const methods = useFormContext<any>();
  if (!methods) return null;
  const { register } = methods;

  return (
    <InputBase
      name="redirect"
      inputRef={register}
      value={url ?? ""}
      style={{ display: "none" }}
    />
  );
});

const ConnectedRedirect = memo<{ url: UrlSelector }>(({ url }) => {
  const resolved = useSelector(url);
  return <DummyRedirect url={resolved ?? null} />;
});

export type RedirectProps = {
  url: string | UrlSelector | null;
};

export const Redirect: React.FC<RedirectProps> = ({ url }) => {
  return typeof url === "function" ? (
    <ConnectedRedirect url={url} />
  ) : (
    <DummyRedirect url={url ?? null} />
  );
};
